import dynamic from "next/dynamic";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import "swiper/css";
import { getExclusiveOffersData } from "@/services/get-exclusive-offers";
const Campaign = dynamic(() => import("@/components/campaign/Campaign"));


export default function Index({bannersData = []}) {
  const { t, locale } = useI18n();

  return (
    <>
      <Box
        className="section-safe-padding-top"
        sx={{
          width: "100%",
          // py: 3,
          overflow: "hidden",
          "& .offersSwiper": {
            overflow: { xs: "visible", lg: "hidden" },
            mx: { xs: 6, lg: 8 },
            // direction: "ltr",
          },

          "& .swiper-slide": {
            display: "flex",
            justifyContent: "center",
            transition: "transform 0.5s ease, opacity 0.5s ease",
            transform: "scale(0.85)",
            // opacity: 0.5,
          },

          "& .swiper-slide-active": {
            transform: "scale(1)",
            opacity: 1,
            zIndex: 2,
          },

          "& .slideCard": {
            width: "100%",
            // maxWidth: { xs: 220, sm: 260, md: 400, lg: 500 },
            borderRadius: "14px",
            overflow: "hidden",
          },

          "& .slideImage": {
            width: "100%",
            display: "block",
            borderRadius: "14px",
          },
        }}
      >
        <Swiper
        dir="ltr"
          modules={[Autoplay]}
          loop
          centeredSlides
          slidesPerView={1.2}
          spaceBetween={5}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            500: { slidesPerView: 1.5 },
            1200: { slidesPerView: 3 },
          }}
          className="offersSwiper"
        >
          {bannersData.map((item) => (
            <SwiperSlide key={item?.id}>
              <Box className="slideCard">
                <Box
                  component="img"
                  src={item?.img}
                  alt={item?.alt_img || `banner-${item?.id}`}
                  className="slideImage"
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Box className="horizontal-safe-padding vertical-safe-padding">
        <Campaign
          type="exclusive-offers"
          title={t.Campaign.catalogueTitle}
          subTitle={t.Campaign.catalogueSubTitle}
          source={process.env.NEXT_PUBLIC_MODE === "PRODUCTION" ? 199 : 201}
          isCatalogueStyle={false}
          isCenter={true}
        />
      </Box>
    </>
  );
}


export async function getServerSideProps({ res }) {
  try { 
    res.setHeader(
      "Cache-Control",
      "no-store, no-cache, must-revalidate, proxy-revalidate"
    );

    const { bannersData } = await getExclusiveOffersData();

    return {
      props: {
        bannersData: bannersData || [],
      },
    };
  } catch (error) {

    return {
      props: {
        bannersData: [],
      },
    };
  }
}